import { render, staticRenderFns } from "./DistZone.vue?vue&type=template&id=37756014&scoped=true"
import script from "./DistZone.vue?vue&type=script&lang=js"
export * from "./DistZone.vue?vue&type=script&lang=js"
import style0 from "./DistZone.vue?vue&type=style&index=0&id=37756014&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37756014",
  null
  
)

export default component.exports